import React from 'react';
import { StyledModalTrimModuleDetailsContainer } from './styles';
import ModalDealerCard from '../modal-dealer-card';
import { CustomImage, TextCustom } from '@ngw6/us-components';
import { modalTitleTextStyle } from './helpers';
import { TrimModuleDetailsLayerState } from '../../typing/modal-display';
import { AppConstants } from '../../utils/app-constants';
import { OfferDetailsCard } from '../offer-details-card';
import { LayerCloseHandleV2 } from '@volkswagen-onehub/layer-manager';
import ModalCloseButton from '../close-button';

const ModalTrimModuleDetails = (
  state: TrimModuleDetailsLayerState,
  close: LayerCloseHandleV2<void>,
  // ,options: LayerRenderOptionsV2 // NOTE: Just for information about layers
): JSX.Element => {
  const { translations, dealer, offer, model} = state;
  const onHandleInternalClose = () => {
    close && close();
    // onCloseHandler && onCloseHandler();
  };
  
  return (
    <>
    <ModalCloseButton onClick={onHandleInternalClose} />
    <StyledModalTrimModuleDetailsContainer className="modal-trim-module_container">
      
      <div className="trim-module-modal_title">
        <TextCustom {...modalTitleTextStyle}>
          {translations.modalTitle}
        </TextCustom>
      </div>
      <div className="trim-module-modal_image">
        <CustomImage
          src={model?.carImage || AppConstants.NoFoundImageError348x196}
          alt={model?.carImageAlt || ""}
          srcPlaceholder={AppConstants.PlaceHolder960x432}
        />
      </div>
      <div className="trim-module-modal_dealer-details">
        <ModalDealerCard dealer={dealer} translations={translations} />
      </div>
      <div className="trim-module-modal_offer-details">
        <OfferDetailsCard offer={offer} />
      </div>
    </StyledModalTrimModuleDetailsContainer>
    </>
  );
};

export default ModalTrimModuleDetails;
